// assets/component-slider.js
(function () {
  'use strict';

  function initAnnouncementSlider(el) {
    if (!el || el.dataset._sliderInit === 'true') return;
    el.dataset._sliderInit = 'true';

    const slider = el.querySelector('.slider');
    if (!slider) {
      console.warn('Slideshow: .slider element not found inside', el);
      return;
    }

    const slides = Array.from(el.querySelectorAll('.slider__slide'));
    if (!slides.length) {
      console.warn('Slideshow: no slides found inside', el);
      return;
    }

    const prevBtn = el.querySelector('.slider-button--prev');
    const nextBtn = el.querySelector('.slider-button--next');

    // read attributes (liquid sets data-autoplay and data-speed on the .slider)
    const autoplayAttr = slider.getAttribute('data-autoplay') ?? slider.dataset.autoplay;
    const speedAttr = slider.getAttribute('data-speed') ?? slider.dataset.speed;
    const autoRotate = String(autoplayAttr) === 'true' || autoplayAttr === '1';
    const rotateSpeed = (parseFloat(speedAttr) || 5) * 1000;

    let currentIndex = 0;
    let autoplayInterval = null;

    // accessibility & initial classes
    el.tabIndex = el.tabIndex >= 0 ? el.tabIndex : 0;
    if (slides.length <= 1) {
      // hide nav if there's only one slide
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
    }

    function showSlide(index, setFocus = false) {
      index = (index + slides.length) % slides.length;
      currentIndex = index;

      slides.forEach((slide, i) => {
        const active = i === index;
        slide.style.display = active ? '' : 'none'; // '' lets CSS decide (usually block)
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.classList.toggle('is-active', active);
        slide.setAttribute('tabindex', active ? '0' : '-1');
      });

      // move focus optionally (useful for keyboard)
      if (setFocus) {
        const activeSlide = slides[index];
        if (activeSlide) activeSlide.focus({ preventScroll: true });
      }
    }

    function nextSlide() {
      showSlide((currentIndex + 1) % slides.length);
    }

    function prevSlide() {
      showSlide((currentIndex - 1 + slides.length) % slides.length);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoRotate || slides.length <= 1) return;
      autoplayInterval = setInterval(() => nextSlide(), rotateSpeed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    function restartAutoplay() {
      if (!autoRotate) return;
      stopAutoplay();
      startAutoplay();
    }

    // Button handlers
    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        nextSlide();
        restartAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        prevSlide();
        restartAutoplay();
      });
    }

    // Keyboard support (Left / Right)
    el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        restartAutoplay();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        restartAutoplay();
        e.preventDefault();
      }
    });

    // Touch / swipe support for mobile
    (function addTouch() {
      let startX = null;
      el.addEventListener('touchstart', (ev) => {
        if (ev.touches && ev.touches.length === 1) startX = ev.touches[0].clientX;
      }, { passive: true });

      el.addEventListener('touchend', (ev) => {
        if (startX === null) return;
        const endX = (ev.changedTouches && ev.changedTouches[0] && ev.changedTouches[0].clientX) || 0;
        const dx = endX - startX;
        const threshold = 40; // px
        if (Math.abs(dx) > threshold) {
          if (dx < 0) nextSlide();
          else prevSlide();
          restartAutoplay();
        }
        startX = null;
      }, { passive: true });
    }());

    // initial show
    showSlide(0);

    // Start autoplay if enabled
    if (autoRotate) startAutoplay();

    // cleanup on DOM removal (optional)
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const removed of m.removedNodes) {
          if (removed === el) {
            stopAutoplay();
            observer.disconnect();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // expose for debugging
    el.__announcementSlider = {
      next: nextSlide,
      prev: prevSlide,
      start: startAutoplay,
      stop: stopAutoplay,
    };
  }

  function initAllSliders() {
    document.querySelectorAll('slideshow-component.announcement-bar, slideshow-component').forEach((el) => {
      initAnnouncementSlider(el);
    });
  }

  // Run on ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSliders);
  } else {
    initAllSliders();
  }

  // Re-initialize after theme editor/section re-render events (Shopify Sections)
  // Some themes fire 'shopify:section:load' and 'shopify:section:reorder' — listen generally:
  window.addEventListener('shopify:section:load', initAllSliders);
  window.addEventListener('shopify:section:unload', initAllSliders);
  window.addEventListener('shopify:section:select', initAllSliders);
  window.addEventListener('shopify:section:deselect', initAllSliders);
})();
